<template>
	<v-layout>
	<v-flex>
		<Delete v-if="dialog" />
		<v-btn flat small :to="{name: 'usersAdd'}" v-if="canAdd()" color="primary">
			<v-icon>add</v-icon>
			{{translater.__('Add user', 'users')}}
		</v-btn>
		<v-card>

			<v-text-field
		        v-model="search"
		        append-icon="search"
		        :label="translater.__('Search')"
		        single-line
		        hide-details
	      ></v-text-field>
			<v-data-table
				:headers="headers"
				:items="this.$store.getters['users/indexDT']"
				:loading="this.$store.getters['users/loading']"
				:search="search"
				class="elevation-1"
				:rows-per-page-text="translater.__('rows per page', 'dt')"
				:rows-per-page-items="[5,10,15,25, {text: translater.__('All', 'dt'), value:-1}]"
				
			>
			<template slot="pageText" slot-scope="{ pageStart, pageStop }">
			    {{
			    	translater.__("rows {0} - {1}", 'dt', pageStart, pageStop)
			    }}
			</template>
			<template slot="no-data">
				{{
					translater.__("Nothing to show")
				}}
			</template>
		    <template slot="items" slot-scope="props">
		      <tr @click="toggle(props)" id="prop.item.id">
		      	  	
			      <td class="text-xs-left">
			      	{{props.item.username}}
			      </td>
			      <td class="text-xs-left">{{
			      	props.item.role
			      }}</td>
			  </tr>
			  

		      
		    </template>
		    <template slot="expand" slot-scope="props">
		    <v-card flat>
		      <v-card-text>
		      	<v-btn v-if="canEdit()" small flat  :to="{name: 'usersEdit', params: {id: selected.id}}">
		      		<v-icon>edit</v-icon>
		      		{{ translater.__("Edit")}}</v-btn>
		      	<v-btn v-if="canEdit()" small flat  :to="{name: 'usersChangePassword', params: {id: selected.id}}">
		      		<v-icon>edit</v-icon>
		      		{{
		      		translater.__("Change Password", "users")
		      	}}</v-btn>
		      	<!--v-btn v-if="canShow()" small class="info" :to="{name: 'usersShow', params: {id: selected.id}}">{{
		      		translater.__("Show")
		      	}}</v-btn-->
		      	<v-btn v-if="canDelete()" small flat  @click.stop="dialog = true">
		      		<v-icon>delete</v-icon>{{
		      		translater.__("Delete")
		      	}}</v-btn>
		      	
		      </v-card-text>
		    </v-card>
		  </template>
		  	
		    
			</v-data-table>
		</v-card>
	</v-flex>
	</v-layout>
</template>

<script>
	import {translater} from '../../tools/translate';
	import Delete from './Delete'
	

	export default {
		name: 'UsersIndex',
		components: {
			Delete
		},

		data()
		{
			return {
				
				//selected: undefined,
				
				headers: [
					
					{
						text: translater.__("Username", "users"),
						value: 'username'
					},
					{
						text: translater.__("Role", "users"),
						value: 'role'
					}
				],
				translater: translater,
				menu : false
				
			}
		},

		computed: {
			search: {
				get()
				{
					return this.$store.getters['users/search'];
				},

				set(value)
				{
					this.$store.dispatch('users/setSearch', value)
				}
			},

			dialog: {
				get()
				{
					return this.$store.getters['users/showDeleteConfirmation'];
				},

				set(value)
				{
					this.$store.dispatch('users/setShowDeleteConfirmation', value);
				}
			},

			selected: {
				get()
				{
					return this.$store.getters['users/selected'];
				},

				set(value)
				{
					
					this.$store.dispatch('users/setSelected', value);
				}
			},

			/*translater: {
				get()
				{
					return this.$store.getters['translate/translater']
				}
			}*/
		},

		created()
		{
			
			this.$store.dispatch('users/indexDT');

			

			
		},
		methods: {
			toggle(props)
			{	
				

				this.selected = props.item;
				props.expanded = !props.expanded

			},
			canEdit()
			{
				return this.$store
					.getters['usersAuthorization/canEdit'];

				
			},

			canShow()
			{
				return  this.$store
					.getters['usersAuthorization/canShow'];
			},

			canDelete()
			{
				return this.$store
					.getters['usersAuthorization/canDelete']
			},

			canAdd()
			{
				return this.$store
					.getters['usersAuthorization/canAdd']
			},

			deleteUser()
			{

			}


		}
		
		
	}
</script>